import * as React from 'react';
import PropTypes from 'prop-types';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import useDebounce from '../../../utils/useDebounce';
import { searchTaskNames } from '../../../redux/taskNameSuggestion/actions';
import { SEARCH_TASK_NAMES_ERROR } from '../../../redux/taskNameSuggestion/types';

const TaskNameAutocomplete = ({
  taskTypeId,
  onChange,
  value,
  validation,
  ...rest
}) => {
  const dispatch = useDispatch();

  // React state
  const [searchField, setSearchField] = React.useState('');

  // Redux state
  const selectedBarn = useSelector((state) => state.barn.selectedBarn)
  const isSearchingTaskNames = useSelector((state) => state.taskNameSuggestion.isSearchingTaskNames);
  const suggestedTaskNames = useSelector((state) => state.taskNameSuggestion.suggestedTaskNames);

  const debouncedSearch = useDebounce(searchField, 500);

  React.useEffect(() => {
    onChange({ target: { value: debouncedSearch || value } })
    if (taskTypeId) {
      dispatch(searchTaskNames(selectedBarn.id, taskTypeId, debouncedSearch, 0, 50, '&sort=taskName,asc'));
    } else {
      dispatch({ type: SEARCH_TASK_NAMES_ERROR }) // will reset list
    }
  }, [debouncedSearch, taskTypeId]);

  return (
    <Autocomplete
      freeSolo
      id="task-names-select-autocomplete"
      onChange={onChange}
      loading={isSearchingTaskNames}
      filterOptions={(x) => x}
      options={suggestedTaskNames.content.map((stn) => stn.taskName)}
      value={value}
      isOptionEqualToValue={(option, valueCompare) => option === valueCompare}
      {...rest}
      noOptionsText={<>No suggested task names found. Provide a new task name and it will be available for future use.</>}
      renderInput={(params) => (
        <TextField
          {...params}
          {...rest}
          fullWidth
          onChange={(e) => { setSearchField(e.target.value); }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isSearchingTaskNames
                  ? <CircularProgress color="inherit" size={20} />
                  : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={!!validation}
          helperText={validation && validation}
        />
      )}
    />
  );
};

TaskNameAutocomplete.propTypes = {
  taskTypeId: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  validation: PropTypes.string,
};

TaskNameAutocomplete.defaultProps = {
  taskTypeId: null,
  value: null,
  validation: null,
};

export default TaskNameAutocomplete;
